import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import {
  AbcAccordionComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcSelectBoxComponent,
} from '@barthauer/abc/ui-components';
import {
  DxButtonModule,
  DxFormModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { CompaniesCardListComponent } from './companies-card-list/companies-card-list.component';
import { CompaniesService } from './companies.service';
import { CompanyCardComponent } from './company-card/company-card.component';
import { ProjectCardComponent } from './project-card/project-card.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatCardModule,
    MatIconModule,
    DxScrollViewModule,
    DxPopupModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxFormModule,
    AbcAccordionComponent,
    AbcTextBoxComponent,
    _AbcSelectBoxComponent,
    _AbcButtonComponent,
    DatePipe,
  ],
  declarations: [CompaniesCardListComponent, ProjectCardComponent, CompanyCardComponent],
  exports: [CompaniesCardListComponent, ProjectCardComponent, CompanyCardComponent],
  providers: [CompaniesService],
})
export class CompaniesModule {}
